import { TickCircleIcon } from '@THC/components/Icons';
import { MDText } from 'i18n-react';

import LocalTexts from '../../EarlyDocuments.texts';

import { EarlyDocumentsCard } from './EarlyDocumentsCard';

import styles from './EarlyDocumentsCards.module.scss';

const LocalT = new MDText(LocalTexts);

interface EarlyDocumentsCardsProps {
	showProofOfAddress: boolean;
}

export const EarlyDocumentsCards = ({ showProofOfAddress }: EarlyDocumentsCardsProps) => {
	const cards = ['drivingLicence', 'v5c', ...(showProofOfAddress ? ['proofOfAddress'] : [])];
	return (
		<div className={styles.container}>
			{cards.map((label) => (
				<EarlyDocumentsCard key={label} icon={<TickCircleIcon />}>
					{LocalT.translate(`cards.${label}`)}
				</EarlyDocumentsCard>
			))}
		</div>
	);
};
